<div class="panel">
  <div class="toggle">
    <label class="option" *ngIf="parametros?.monthly === 'S'">
      <input
        type="radio"
        name="pagamento"
        [(ngModel)]="tipoPagamento"
        value="mensal"
        (change)="onChangeTipoPagamento('mensal')"
      />
      <span>Financiamento Mensal</span>
    </label>
    <label class="option" *ngIf="exibirParcelasFlexiveis">
      <input
        type="radio"
        name="pagamento"
        [(ngModel)]="tipoPagamento"
        value="flexivel"
        (change)="onChangeTipoPagamento('flexivel')"
        [checked]="parametros?.monthly !== 'S'" 
      />
      <span>Financiamento Flexível</span>
    </label>
  </div>

  <p class="border-flexivel"></p>
  <h3 class="title">SELECIONE O VALOR DAS PARCELAS</h3>

  <!-- PAGAMENTO MENSAL -->
  <div
    class="container"
    [hidden]="tipoPagamento !== 'mensal' || parametros?.monthly !== 'S'"
  >
    <p class="subtitle" *ngIf="proposta.taxaCliente.parcelaMax > 0">
      Valor máximo por parcela
      {{ proposta.taxaCliente.parcelaMax | currency:'BRL':'symbol':'1.2-2' }}
    </p>

    <div class="parcelas">
      <div class="parcela" *ngFor="let parcela of parcelasSimuladas.slice().reverse()">
        <ng-container *ngIf="parcela.periodicidadePagamento === 1">
          <input
            type="radio"
            name="radioParcelas"
            [id]="'parcela-' + parcela.quantidade"
            [value]="parcela.quantidade"
            (change)="onSelectParcelaFlexivel(parcela, parcela.taxa)"
            [checked]="
              parcelaSelecionadaMensal?.quantidade === parcela.quantidade &&
              parcelaSelecionadaMensal?.periodicidadePagamento === 1
            "
            [disabled]="!parcela.exibir"
          />
          <label [for]="'parcela-' + parcela.quantidade">
            <div class="parcela-texto">
              <strong>{{ parcela.quantidade }}x</strong>
              <span>{{ parcela.valor | currency:'BRL' }}</span>
            </div>
          </label>
        </ng-container>
      </div>
      <app-flexible-message></app-flexible-message>
    </div>
  </div>

  <!-- PAGAMENTO FLEXÍVEL -->
  <div [hidden]="tipoPagamento !== 'flexivel'">
    <div
      class="panel-flexivel"
      *ngFor="let parcela of parcelasSimuladas.slice().reverse(); let i = index"
    >
      <h4
        class="meses"
        *ngIf="
          parcela.periodicidadePagamento === 1 &&
          parcela.parcelasFlexiveis?.length > 0
        "
      >
        {{ parcela.quantidade }} Meses
      </h4>

      <ng-container
        *ngFor="let flex of parcela.parcelasFlexiveis.slice().reverse(); let j = index"
      >
        <!-- Semanal -->
        <div
          class="parcela-flexivel"
          *ngIf="flex.periodicidadePagamento === 7 && parametros?.weekly === 'S'"
        >
          <input
            type="radio"
            name="opcaoFlexivel"
            [id]="'op-semanal-' + i + '-' + j"
            [value]="flex.quantidade"
            (change)="onSelectParcelaFlexivel(flex, parcela.taxa)"
            [checked]="
              parcelaSelecionadaFlexivel?.quantidade === flex.quantidade &&
              parcelaSelecionadaFlexivel?.periodicidadePagamento === flex.periodicidadePagamento
            "
            [disabled]="!flex.exibir"
          />
          <label [for]="'op-semanal-' + i + '-' + j">
            <span class="texto">
              <strong>Semanal:</strong>
              <span class="valor"
                >{{ flex.quantidade }}x de
                {{ flex.valor | currency:'BRL':'symbol':'1.2-2' }}</span
              >
            </span>
          </label>
        </div>

        <!-- Decendial -->
        <div
          class="parcela-flexivel"
          *ngIf="flex.periodicidadePagamento === 10 && parametros?.decennial === 'S'"
        >
          <input
            type="radio"
            name="opcaoFlexivel"
            [id]="'op-decendial-' + i + '-' + j"
            [value]="flex.quantidade"
            (change)="onSelectParcelaFlexivel(flex, parcela.taxa)"
            [checked]="
              parcelaSelecionadaFlexivel?.quantidade === flex.quantidade &&
              parcelaSelecionadaFlexivel?.periodicidadePagamento === flex.periodicidadePagamento
            "
            [disabled]="!flex.exibir"
          />
          <label [for]="'op-decendial-' + i + '-' + j">
            <span class="texto">
              <strong>A cada 10 dias:</strong>
              <span class="valor"
                >{{ flex.quantidade }}x de
                {{ flex.valor | currency:'BRL':'symbol':'1.2-2' }}</span
              >
            </span>
          </label>
        </div>

        <!-- Quinzenal -->
        <div
          class="parcela-flexivel"
          *ngIf="flex.periodicidadePagamento === 14 && parametros?.biweekly === 'S'"
        >
          <input
            type="radio"
            name="opcaoFlexivel"
            [id]="'op-quinzenal-' + i + '-' + j"
            [value]="flex.quantidade"
            (change)="onSelectParcelaFlexivel(flex, parcela.taxa)"
            [checked]="
              parcelaSelecionadaFlexivel?.quantidade === flex.quantidade &&
              parcelaSelecionadaFlexivel?.periodicidadePagamento === flex.periodicidadePagamento
            "
            [disabled]="!flex.exibir"
          />
          <label [for]="'op-quinzenal-' + i + '-' + j">
            <span class="texto">
              <strong>Quinzenal:</strong>
              <span class="valor"
                >{{ flex.quantidade }}x de
                {{ flex.valor | currency:'BRL':'symbol':'1.2-2' }}</span
              >
            </span>
          </label>
        </div>
      </ng-container>
    </div>
    <app-flexible-message></app-flexible-message>
  </div>
</div>

<!-- PRIMEIRA PARCELA -->
<div class="panel">
  <h3>Primeira Parcela</h3>
  <p class="border">
    {{ simulacao.primeiraParcela * 1000 | date: 'dd/MM/yyyy' }}
  </p>
  <calendar
    [titleButton]="'alterar'"
    [titleCalendar]="'Data para pagamento'"
    [startDate]="dataCarenciaMinima"
    [endDate]="dataCarenciaMaxima"
    [dateSelected]="simulacao.primeiraParcela"
    (dateSelectedChange)="onChangePrimeiraParcela($event)"
  ></calendar>
</div>
